export const TakerDeserializer = data => {
  if (data.message) {
    return { message: data.message };
  }

  const { user } = data;
  return {
    id: user.id,
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    cell_phone: user.cell_phone,
    divisionId: user.taker_division,
    role: user.role.abbreviation,
    feedback_groups: data.feedback_groups,
    token: { digest: data.token },
  };
};
